const SearchText = (function() {
    /**
     * bindSearchTextField : binding text fields
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param event object
     * @param defaultConfig object
     * @param config object
     */
    const searchTextField = (event, defaultConfig = {}, config = {}) => {
        let input, filter, table, tr, td, i, txtValue;
        input = defaultConfig.analyserTransactionsTableDataSearchText[0];
        filter = input.value.toUpperCase();
    };
    return {};
})();
